import { useEffect } from 'react'

const useClickOutside = (callback, ref, isArray = false) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (!isArray) {
        if (ref.current && !ref.current.contains(event.target)) {
          callback()
        }
      } else {
        ref.forEach((el) => {
          if (
            !el.current.contains(event.target) ||
            el.current.querySelector(':scope > *').contains(event.target)
          ) {
            callback()
            console.log(el, event)
          }
        })
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, callback, isArray])
}

export default useClickOutside
